import { useQuery } from '@tanstack/react-query';
import fetchWebApi from 'api/fetchWebApi';

type ClientEmail = {
  email: string;
};

const useClientEmailQuery = () => {
  return useQuery<ClientEmail>(
    ['client', 'email'],
    async () => fetchWebApi('/client/email'),
    {
      enabled: !!sessionStorage.getItem('token'),
    },
  );
};

export default useClientEmailQuery;
